// API Configuration
export const API_CONFIG = {
  BASE_URL: 'https://tc8ozft3ek.execute-api.sa-east-1.amazonaws.com',
  API_KEY: process.env.REACT_APP_API_KEY || '',
  TIMEOUT: 30000
};

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: '/auth/register',
    REQUEST_CODE: '/auth/request-code',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    VERIFY: '/auth/verify'
  },
  COURSES: {
    LIST: '/courses',
    GET: (id) => `/courses/${id}`
  },
  ENROLLMENTS: {
    LIST: '/enrollments',
    CREATE: '/enrollments'
  }
};

// Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'auth_token',
  USER: 'user_data'
};
